module.exports = __webpack_public_path__ + "static/media/bb.0c916c1c.svg";